import defaultLang from "Const/language"

export const getInitLang = (lang) => {
  const hashUrl = window.location.hash.split("?")
  const joinQuery = hashUrl.slice(1, hashUrl.length).join("")
  const query = new URLSearchParams(joinQuery)
  let queryLang = query.get("language")
  if(!defaultLang.includes(queryLang)) queryLang = false
  // let userLang = navigator.language || navigator.userLanguage
  // const naviLang = transToLowercaseAndTrim(userLang)
  // if (
  //   naviLang === 'zh-tw' ||
  //   naviLang === 'zh-cn' ||
  //   naviLang === 'cn' ||
  //   naviLang === 'zh' ||
  //   naviLang === 'tw'
  // ) {
  //   lang = 'cn'
  // } else lang = 'en'
  if(queryLang === 'zh-cn' || queryLang === 'zh-tw') queryLang = 'cn'
  return queryLang || lang
}

export const gameLinkLang = (lang) => {
  lang = transToLowercaseAndTrim(lang)
  if (lang === "cn") lang = "zh-cn"
  return lang
}

export const transToLowercaseAndTrim = (str) => str.toLowerCase().trim()
